var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.112 19.324V22.168H4.78401C4.98921 24.5608 5.83042 26.8552 7.22122 28.8136C8.61202 30.7708 10.5008 32.3212 12.692 33.304C19.22 36.376 27.512 35.152 34.196 29.536L36.812 32.692C32.2472 36.676 26.4296 38.932 20.372 39.064C17.1368 39.07 13.9412 38.3608 11.012 36.988C7.80442 35.5084 5.10202 33.1168 3.24322 30.1132C1.38562 27.1084 0.45199 23.6236 0.55999 20.092C0.62239 14.8804 2.72358 9.9004 6.41358 6.22C10.1036 2.5396 15.0884 0.450394 20.3 0.399994C31.1 0.399994 40.04 9.38799 40.04 19.372L40.112 19.324ZM35.888 18.124C35.276 10.744 28.688 4.456 20.288 4.456C11.888 4.456 5.312 10.744 4.772 18.124H35.888Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerE);
export default __webpack_public_path__ + "static/media/LOWER_E.5122bd42f660dc84532225f2fa2efcac.svg";
export { ForwardRef as ReactComponent };